function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "prefix__a",
  width: "135%",
  height: "135%",
  x: "-17.5%",
  y: "-12.5%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
})), React.createElement("circle", {
  id: "prefix__b",
  cx: 20,
  cy: 20,
  r: 20
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(4 2)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#prefix__a)",
  xlinkHref: "#prefix__b"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#prefix__b"
}), React.createElement("path", {
  fill: "#ABABAB",
  fillRule: "nonzero",
  d: "M20 28c.933 0 1.4-.462 1.4-1.385v-9.893l3.184 3.149c.294.29.62.436.978.436.37 0 .703-.142.997-.427.294-.284.441-.616.441-.995 0-.354-.147-.67-.441-.949l-5.39-5.33c-.408-.404-.811-.606-1.207-.606-.346 0-.723.202-1.132.607l-5.389 5.33c-.294.277-.441.594-.441.948 0 .379.147.71.441.995.294.285.627.427.997.427.358 0 .684-.145.978-.436l3.184-3.149v9.893c0 .923.467 1.385 1.4 1.385z"
}));

var SvgScrollTop = function SvgScrollTop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScrollTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scroll_top.c0742fe9.svg";
export { ForwardRef as ReactComponent };